window.dateLibrary = [
{
name:"❤️ Relationship Time Capsule",
location:"inside",
budget:"free",
vibes:[
"romantic",
"creative",
"relaxing"
],
difficulty:"easy",
time:"30-60 minutes",
description:"Create a time capsule together. Write down where you are in life, your favorite memories, hopes for the future, and things you love about each other.",
supplies:[
"Paper",
"Pens",
"Envelope or box"
],
memory:"Take a photo of your time capsule and choose a future date to open it."
},


{
name:"🕯️ Candlelight Dinner At Home",
location:"inside",
budget:"cheap",
vibes:[
"romantic",
"foodie",
"relaxing"
],
difficulty:"easy",
time:"1-2 hours",
description:"Turn an ordinary dinner into something special. Dim the lights, dress up, and pretend you are at a fancy restaurant.",
supplies:[
"Food ingredients",
"Candles or lights",
"Music playlist"
],
memory:"Take a photo of your homemade restaurant experience."
},


{
name:"💬 Deep Question Night",
location:"inside",
budget:"free",
vibes:[
"romantic",
"relaxing",
"creative"
],
difficulty:"easy",
time:"30-60 minutes",
description:"Take turns answering meaningful questions about your dreams, memories, fears, and future goals.",
supplies:[
"Question list",
"Drinks",
"Comfortable space"
],
memory:"Save your favorite answer from the night."
},


{
name:"🏰 Blanket Fort Adventure",
location:"inside",
budget:"free",
vibes:[
"silly",
"romantic",
"relaxing"
],
difficulty:"easy",
time:"1-2 hours",
description:"Build the ultimate blanket fort and spend the evening inside it watching movies, talking, or playing games.",
supplies:[
"Blankets",
"Pillows",
"Snacks"
],
memory:"Take a photo of your ridiculous fort creation."
},


{
name:"🍿 Movie Character Challenge",
location:"inside",
budget:"free",
vibes:[
"silly",
"relaxing",
"creative"
],
difficulty:"easy",
time:"1-2 hours",
description:"Pick a movie and choose characters for each other. Act like those characters during the movie night.",
supplies:[
"A movie",
"Snacks",
"Imagination"
],
memory:"Save your funniest character moment."
},


{
name:"🎲 Board Game Battle",
location:"inside",
budget:"free",
vibes:[
"silly",
"relaxing",
"creative"
],
difficulty:"easy",
time:"1-2 hours",
description:"Choose your favorite board games and compete in a friendly tournament. Create a winner's title.",
supplies:[
"Board games",
"Snacks",
"Score sheet"
],
memory:"Take a winner photo and record the final score."
},


{
name:"🍪 Bake Something New",
location:"inside",
budget:"cheap",
vibes:[
"creative",
"foodie",
"romantic"
],
difficulty:"easy",
time:"1-2 hours",
description:"Choose a recipe neither of you has tried before and bake it together. Bonus points for making it look ridiculous.",
supplies:[
"Baking ingredients",
"Recipe",
"Camera"
],
memory:"Take a photo of your creation before eating it."
},


{
name:"🎵 Build Our Playlist",
location:"inside",
budget:"free",
vibes:[
"romantic",
"creative",
"relaxing"
],
difficulty:"easy",
time:"30-60 minutes",
description:"Create a playlist that represents your relationship. Add songs from memories, milestones, and moments together.",
supplies:[
"Phone",
"Music app"
],
memory:"Save the playlist as a relationship soundtrack."
},


{
name:"🧩 Puzzle & Conversation Night",
location:"inside",
budget:"cheap",
vibes:[
"relaxing",
"romantic",
"creative"
],
difficulty:"easy",
time:"1-2 hours",
description:"Work on a puzzle together while talking about life, memories, and future plans.",
supplies:[
"Puzzle",
"Drinks",
"Comfortable space"
],
memory:"Take a photo when the puzzle is complete."
},


{
name:"📸 Old Photos Story Night",
location:"inside",
budget:"free",
vibes:[
"romantic",
"relaxing",
"creative"
],
difficulty:"easy",
time:"1 hour",
description:"Look through old photos and share stories behind your favorite memories.",
supplies:[
"Old photos",
"Phone albums"
],
memory:"Choose one favorite photo and save why it matters."
},{
name:"🛒 Dollar Store Challenge",
location:"inside",
budget:"cheap",
vibes:[
"silly",
"creative",
"adventure"
],
difficulty:"easy",
time:"1-2 hours",
description:"Go to a dollar store and give each other a small budget. Buy something funny, useful, or completely ridiculous for each other.",
supplies:[
"Small budget",
"Dollar store",
"Creativity"
],
memory:"Take a photo showing your weird purchases."
},


{
name:"🎨 Bad Art Competition",
location:"inside",
budget:"free",
vibes:[
"silly",
"creative",
"romantic"
],
difficulty:"easy",
time:"30-60 minutes",
description:"Try to draw each other, your pets, or random objects. The worse the artwork, the better.",
supplies:[
"Paper",
"Markers or pencils"
],
memory:"Save your funniest masterpiece."
},


{
name:"🤔 Who Knows Who Better?",
location:"inside",
budget:"free",
vibes:[
"silly",
"romantic",
"relaxing"
],
difficulty:"easy",
time:"30-60 minutes",
description:"Create questions about each other and see who knows their partner best.",
supplies:[
"Paper",
"Pens",
"Questions"
],
memory:"Save your funniest wrong answers."
},


{
name:"🍕 Create The Worst Meal",
location:"inside",
budget:"cheap",
vibes:[
"silly",
"foodie",
"creative"
],
difficulty:"easy",
time:"1-2 hours",
description:"Try to create the strangest meal possible using random ingredients. Judge each other's creations.",
supplies:[
"Random ingredients",
"Cooking supplies"
],
memory:"Take a photo of the final disaster."
},


{
name:"🎭 Impression Challenge",
location:"inside",
budget:"free",
vibes:[
"silly",
"creative"
],
difficulty:"easy",
time:"30-60 minutes",
description:"Take turns doing impressions of celebrities, characters, friends, or each other.",
supplies:[
"Imagination",
"Phone camera"
],
memory:"Record your funniest impression."
},


{
name:"📱 No Context Photo Challenge",
location:"inside",
budget:"free",
vibes:[
"silly",
"creative"
],
difficulty:"easy",
time:"1 hour",
description:"Take random funny photos around your home with no explanation. Try to make the weirdest picture possible.",
supplies:[
"Phone camera"
],
memory:"Create a mini album of your strange photos."
},


{
name:"🎤 Living Room Karaoke",
location:"inside",
budget:"free",
vibes:[
"silly",
"creative",
"romantic"
],
difficulty:"easy",
time:"1-2 hours",
description:"Pick songs and perform them like you are on stage. Bonus points for costumes.",
supplies:[
"Music",
"Microphone optional"
],
memory:"Save your best performance photo."
},


{
name:"😂 Try Not To Laugh Challenge",
location:"inside",
budget:"free",
vibes:[
"silly",
"relaxing"
],
difficulty:"easy",
time:"30-60 minutes",
description:"Take turns trying to make each other laugh without touching. The first person who laughs loses.",
supplies:[
"Funny videos",
"Jokes",
"Creativity"
],
memory:"Record the funniest moment."
},


{
name:"🧦 Mystery Outfit Challenge",
location:"inside",
budget:"free",
vibes:[
"silly",
"creative"
],
difficulty:"easy",
time:"30-60 minutes",
description:"Create outfits for each other using only clothes already in the house.",
supplies:[
"Random clothes",
"Accessories"
],
memory:"Take a photo of the final outfits."
},


{
name:"🏆 Make Up Fake Awards",
location:"inside",
budget:"free",
vibes:[
"silly",
"romantic",
"creative"
],
difficulty:"easy",
time:"30-60 minutes",
description:"Create ridiculous awards for each other like 'Best Snack Finder' or 'Most Dramatic Person'.",
supplies:[
"Paper",
"Pens"
],
memory:"Create your official relationship awards ceremony."
},


{
name:"🧪 Weird Drink Taste Test",
location:"inside",
budget:"cheap",
vibes:[
"silly",
"foodie",
"creative"
],
difficulty:"easy",
time:"30-60 minutes",
description:"Choose unusual drinks or flavors and rate them together.",
supplies:[
"Different drinks",
"Score cards"
],
memory:"Save the winning and worst drink rankings."
},


{
name:"🎲 Random Challenge Wheel",
location:"inside",
budget:"free",
vibes:[
"silly",
"adventure",
"creative"
],
difficulty:"easy",
time:"1 hour",
description:"Create a wheel of random challenges and let fate decide what happens next.",
supplies:[
"Paper",
"Spinner app"
],
memory:"Take a photo of the challenge that won."
},{
name:"🎨 Paint A Memory",
location:"inside",
budget:"cheap",
vibes:[
"creative",
"romantic",
"relaxing"
],
difficulty:"easy",
time:"1-2 hours",
description:"Paint something that represents a favorite memory you share together. It does not have to be perfect — the meaning matters more than the art.",
supplies:[
"Paint",
"Canvas or paper",
"Brushes"
],
memory:"Hang your artwork somewhere special."
},


{
name:"🖼️ Create A Couple Collage",
location:"inside",
budget:"free",
vibes:[
"creative",
"romantic",
"relaxing"
],
difficulty:"easy",
time:"1-2 hours",
description:"Make a collage of your favorite moments together using photos, drawings, and memories.",
supplies:[
"Photos",
"Paper",
"Glue"
],
memory:"Take a photo of your finished collage."
},


{
name:"🪴 Build A Tiny Garden",
location:"inside",
budget:"cheap",
vibes:[
"creative",
"relaxing",
"adventure"
],
difficulty:"easy",
time:"1-2 hours",
description:"Create a small indoor plant setup together and choose plants that represent your personalities.",
supplies:[
"Small plants",
"Pots",
"Soil"
],
memory:"Take a photo of your new little garden."
},


{
name:"✂️ DIY Decoration Night",
location:"inside",
budget:"cheap",
vibes:[
"creative",
"relaxing",
"silly"
],
difficulty:"easy",
time:"1-2 hours",
description:"Make something for your home together. Decorate, customize, or create something that represents you both.",
supplies:[
"Craft supplies",
"Ideas",
"Music"
],
memory:"Save a photo of your creation."
},


{
name:"📸 At Home Photo Shoot",
location:"inside",
budget:"free",
vibes:[
"creative",
"silly",
"romantic"
],
difficulty:"easy",
time:"1 hour",
description:"Create your own photo shoot with funny poses, serious pictures, and creative backgrounds.",
supplies:[
"Phone camera",
"Props"
],
memory:"Choose your favorite photo together."
},


{
name:"📝 Write Our Story",
location:"inside",
budget:"free",
vibes:[
"creative",
"romantic",
"relaxing"
],
difficulty:"easy",
time:"1 hour",
description:"Write the story of your relationship from the first meeting until now.",
supplies:[
"Paper",
"Pens"
],
memory:"Save the story and add to it every year."
},


{
name:"🎧 Create A Podcast Episode",
location:"inside",
budget:"free",
vibes:[
"creative",
"silly",
"romantic"
],
difficulty:"easy",
time:"1-2 hours",
description:"Pretend you host a podcast together. Interview each other about memories, opinions, and funny stories.",
supplies:[
"Phone recorder",
"Questions"
],
memory:"Save a short recording of your episode."
},


{
name:"🧱 Build Something Together",
location:"inside",
budget:"cheap",
vibes:[
"creative",
"silly",
"adventure"
],
difficulty:"easy",
time:"1-2 hours",
description:"Build something together using LEGO, blocks, crafts, or whatever materials you have available.",
supplies:[
"Building materials",
"Imagination"
],
memory:"Take a photo of your finished creation."
},


{
name:"🎨 Redesign A Room",
location:"inside",
budget:"free",
vibes:[
"creative",
"relaxing"
],
difficulty:"easy",
time:"1-2 hours",
description:"Pick a room and brainstorm ways to make it more comfortable, fun, or personalized.",
supplies:[
"Paper",
"Pens",
"Ideas"
],
memory:"Save your before and after plans."
},


{
name:"📚 Create A Couple Bucket List",
location:"inside",
budget:"free",
vibes:[
"creative",
"romantic",
"adventure"
],
difficulty:"easy",
time:"30-60 minutes",
description:"Make a list of adventures, goals, places, and experiences you want to share together.",
supplies:[
"Notebook",
"Pens"
],
memory:"Keep the list and check things off over time."
},


{
name:"🎁 Make A Surprise Box",
location:"inside",
budget:"cheap",
vibes:[
"creative",
"romantic",
"relaxing"
],
difficulty:"easy",
time:"1 hour",
description:"Create a box filled with small notes, memories, snacks, or surprises for each other.",
supplies:[
"Box",
"Paper",
"Small items"
],
memory:"Open it together later as a surprise."
},


{
name:"🌈 Color Theme Challenge",
location:"inside",
budget:"cheap",
vibes:[
"creative",
"silly",
"foodie"
],
difficulty:"easy",
time:"1 hour",
description:"Choose a color and create a snack, outfit, decoration, or photo challenge around that theme.",
supplies:[
"Random items",
"Creativity"
],
memory:"Take a themed photo together."
},{
name:"🌲 Explore A New Park",
location:"outside",
budget:"free",
vibes:[
"adventure",
"relaxing",
"romantic"
],
difficulty:"easy",
time:"1-2 hours",
description:"Find a park or trail you have never visited and explore it together. Take your time and see what you discover.",
supplies:[
"Walking shoes",
"Water",
"Phone camera"
],
memory:"Take a photo at your favorite spot."
},


{
name:"🗺️ Random Direction Adventure",
location:"outside",
budget:"free",
vibes:[
"adventure",
"silly",
"creative"
],
difficulty:"easy",
time:"1-2 hours",
description:"Choose a direction and explore somewhere nearby you normally would not visit.",
supplies:[
"Transportation",
"Curiosity"
],
memory:"Save a photo of something unexpected you found."
},


{
name:"📍 Geocaching Adventure",
location:"outside",
budget:"free",
vibes:[
"adventure",
"creative",
"relaxing"
],
difficulty:"easy",
time:"1-2 hours",
description:"Try geocaching together and search for hidden treasures around your area.",
supplies:[
"Phone",
"Walking shoes"
],
memory:"Take a photo when you find your first cache."
},


{
name:"🛍️ Thrift Store Treasure Hunt",
location:"outside",
budget:"cheap",
vibes:[
"adventure",
"silly",
"creative"
],
difficulty:"easy",
time:"1-2 hours",
description:"Visit a thrift store and challenge each other to find the funniest, strangest, or coolest item.",
supplies:[
"Small budget",
"Creativity"
],
memory:"Take a photo with your best discovery."
},


{
name:"📸 Neighborhood Photo Hunt",
location:"outside",
budget:"free",
vibes:[
"creative",
"adventure",
"relaxing"
],
difficulty:"easy",
time:"1 hour",
description:"Create a list of things to find around your neighborhood and photograph them together.",
supplies:[
"Phone camera"
],
memory:"Create an album of your adventure."
},


{
name:"🌅 Sunrise Or Sunset Mission",
location:"outside",
budget:"free",
vibes:[
"romantic",
"adventure",
"relaxing"
],
difficulty:"easy",
time:"1 hour",
description:"Find a beautiful place to watch the sky change together.",
supplies:[
"Blanket",
"Jackets",
"Camera"
],
memory:"Take one photo during the moment."
},


{
name:"🚗 Mystery Drive",
location:"outside",
budget:"cheap",
vibes:[
"adventure",
"romantic",
"silly"
],
difficulty:"easy",
time:"1-2 hours",
description:"Take turns choosing random turns and see where you end up.",
supplies:[
"Vehicle",
"Playlist",
"Snacks"
],
memory:"Save a photo from your unexpected destination."
},


{
name:"☕ New Cafe Challenge",
location:"outside",
budget:"cheap",
vibes:[
"foodie",
"adventure",
"romantic"
],
difficulty:"easy",
time:"1-2 hours",
description:"Visit a cafe you have never tried and order something different from your usual choice.",
supplies:[
"Transportation",
"Curiosity"
],
memory:"Rate the cafe and save your favorite drink."
},


{
name:"🏞️ Scenic Walk Challenge",
location:"outside",
budget:"free",
vibes:[
"romantic",
"adventure",
"relaxing"
],
difficulty:"easy",
time:"1 hour",
description:"Go for a walk somewhere beautiful and focus on talking without distractions.",
supplies:[
"Comfortable shoes",
"Water"
],
memory:"Take a photo together at the halfway point."
},


{
name:"🎯 Pick A Random Destination",
location:"outside",
budget:"cheap",
vibes:[
"adventure",
"creative",
"romantic"
],
difficulty:"easy",
time:"2-3 hours",
description:"Choose a nearby place neither of you has visited and make a mini adventure out of it.",
supplies:[
"Transportation",
"Phone"
],
memory:"Take a picture of your destination."
},


{
name:"🧺 Picnic Anywhere",
location:"outside",
budget:"cheap",
vibes:[
"romantic",
"foodie",
"relaxing"
],
difficulty:"easy",
time:"1-2 hours",
description:"Pack simple food and find a nice place to enjoy a picnic together.",
supplies:[
"Food",
"Blanket",
"Drinks"
],
memory:"Take a photo of your picnic setup."
},


{
name:"🐾 Pet Adventure Walk",
location:"outside",
budget:"free",
vibes:[
"adventure",
"relaxing",
"romantic"
],
difficulty:"easy",
time:"1 hour",
description:"Take your pets or yourselves on a new walking route and explore somewhere different.",
supplies:[
"Leash if needed",
"Water",
"Camera"
],
memory:"Capture a favorite moment from the walk."
},{
name:"🍳 Breakfast For Dinner",
location:"inside",
budget:"cheap",
vibes:[
"foodie",
"silly",
"romantic"
],
difficulty:"easy",
time:"1 hour",
description:"Break the normal routine and make breakfast foods for dinner together.",
supplies:[
"Breakfast ingredients",
"Drinks",
"Music"
],
memory:"Take a photo of your backwards dinner night."
},


{
name:"🌮 Build Your Own Taco Night",
location:"inside",
budget:"cheap",
vibes:[
"foodie",
"creative",
"silly"
],
difficulty:"easy",
time:"1-2 hours",
description:"Create a taco bar and design your perfect tacos. Vote on the best creation.",
supplies:[
"Taco ingredients",
"Toppings",
"Plates"
],
memory:"Take a photo of your winning taco."
},


{
name:"🍰 Dessert Creation Challenge",
location:"inside",
budget:"cheap",
vibes:[
"foodie",
"creative",
"romantic"
],
difficulty:"easy",
time:"1-2 hours",
description:"Create or decorate a dessert together and compete for the best presentation.",
supplies:[
"Dessert ingredients",
"Decorations"
],
memory:"Save a picture before eating it."
},


{
name:"🌎 International Food Night",
location:"inside",
budget:"cheap",
vibes:[
"foodie",
"adventure",
"creative"
],
difficulty:"easy",
time:"1-2 hours",
description:"Choose a country and make or try foods inspired by that culture.",
supplies:[
"Recipe",
"Ingredients",
"Music optional"
],
memory:"Create a photo album of your food adventures."
},


{
name:"🍿 Snack Stadium",
location:"inside",
budget:"cheap",
vibes:[
"foodie",
"silly",
"relaxing"
],
difficulty:"easy",
time:"1-2 hours",
description:"Build the ultimate snack setup with different foods and rate every item.",
supplies:[
"Snacks",
"Drinks",
"Score cards"
],
memory:"Take a photo of your snack masterpiece."
},


{
name:"👨‍🍳 Cook Off Challenge",
location:"inside",
budget:"cheap",
vibes:[
"foodie",
"silly",
"creative"
],
difficulty:"easy",
time:"1-2 hours",
description:"Each person creates a dish and judges the other person's cooking.",
supplies:[
"Ingredients",
"Cooking supplies"
],
memory:"Save the final judging results."
},


{
name:"🍦 Dessert Hunt",
location:"outside",
budget:"cheap",
vibes:[
"foodie",
"adventure",
"romantic"
],
difficulty:"easy",
time:"1-2 hours",
description:"Visit different places and compare desserts to find your favorite.",
supplies:[
"Transportation",
"Budget"
],
memory:"Take photos of your dessert winners."
},


{
name:"🥤 Drink Taste Challenge",
location:"inside",
budget:"cheap",
vibes:[
"foodie",
"silly",
"creative"
],
difficulty:"easy",
time:"30-60 minutes",
description:"Try different drinks and rate them from favorite to worst.",
supplies:[
"Different drinks",
"Paper"
],
memory:"Save your final rankings."
},


{
name:"🎉 Special Occasion Memory Night",
location:"inside",
budget:"medium",
vibes:[
"romantic",
"foodie",
"creative"
],
difficulty:"easy",
time:"2-3 hours",
description:"Create a special evening celebrating your relationship with food, music, and memories.",
supplies:[
"Food",
"Music",
"Photos"
],
memory:"Take a photo of the celebration."
},


{
name:"💎 Recreate Our First Date",
location:"inside",
budget:"medium",
vibes:[
"romantic",
"adventure",
"creative"
],
difficulty:"medium",
time:"2-3 hours",
description:"Recreate your first date as closely as possible or recreate the feeling of that first adventure.",
supplies:[
"Memory ideas",
"Food",
"Photos"
],
memory:"Compare then and now with a photo."
},


{
name:"🎁 Surprise Date Exchange",
location:"inside",
budget:"medium",
vibes:[
"romantic",
"silly",
"creative"
],
difficulty:"easy",
time:"1-2 hours",
description:"Each person secretly plans one small surprise for the other person.",
supplies:[
"Planning",
"Small surprise"
],
memory:"Save the best surprise moment."
},


{
name:"🌟 Dream Night Planning",
location:"inside",
budget:"free",
vibes:[
"romantic",
"creative",
"relaxing"
],
difficulty:"easy",
time:"1 hour",
description:"Plan your dream future together — places to visit, goals, adventures, and memories you want to create.",
supplies:[
"Paper",
"Pens"
],
memory:"Save your dream list for the future."
},

{
name:"🌌 Stargazing Night",
location:"outside",
budget:"splurge",
vibes:[
"romantic",
"adventure",
"relaxing"
],
difficulty:"easy",
time:"2-3 hours",
description:"Create a special night under the stars. Find a quiet location, bring cozy blankets, and spend time talking away from distractions.",
supplies:[
"Blanket",
"Snacks",
"Warm clothes",
"Phone camera"
],
memory:"Take a photo of the stars or your cozy setup."
},


{
name:"🍷 Fancy Tasting Night",
location:"inside",
budget:"splurge",
vibes:[
"romantic",
"foodie",
"creative"
],
difficulty:"easy",
time:"1-2 hours",
description:"Create a fancy tasting experience at home with different foods, drinks, or desserts. Rate everything like professional judges.",
supplies:[
"Tasting items",
"Score cards",
"Nice presentation"
],
memory:"Save your winning item and final rankings."
},


{
name:"🏨 Dream Staycation Night",
location:"inside",
budget:"splurge",
vibes:[
"romantic",
"relaxing",
"adventure"
],
difficulty:"medium",
time:"overnight",
description:"Turn your home into a luxury getaway. Disconnect from normal routines and create a vacation feeling together.",
supplies:[
"Special food",
"Comfort items",
"Activities"
],
memory:"Take a photo of your staycation setup."
},


{
name:"🎭 Live Show Adventure",
location:"outside",
budget:"splurge",
vibes:[
"adventure",
"romantic"
],
difficulty:"medium",
time:"2-4 hours",
description:"Dress up and attend a live performance, comedy show, concert, or event together.",
supplies:[
"Tickets",
"Transportation",
"Camera"
],
memory:"Take a photo before the show begins."
},


{
name:"🧖 Couples Spa Night",
location:"inside",
budget:"splurge",
vibes:[
"romantic",
"relaxing"
],
difficulty:"easy",
time:"1-2 hours",
description:"Create a spa experience together with relaxing music, self-care activities, and time to unwind.",
supplies:[
"Candles",
"Face masks",
"Relaxing music"
],
memory:"Capture your relaxing setup."
},


{
name:"🚗 Mystery Day Trip",
location:"outside",
budget:"splurge",
vibes:[
"adventure",
"romantic"
],
difficulty:"medium",
time:"4-8 hours",
description:"Pick a nearby place you have never explored and make an entire day out of discovering somewhere new.",
supplies:[
"Transportation",
"Snacks",
"Camera"
],
memory:"Take a photo at your destination."
},


{
name:"📸 Couple Photoshoot Adventure",
location:"outside",
budget:"splurge",
vibes:[
"creative",
"romantic"
],
difficulty:"easy",
time:"1-2 hours",
description:"Dress up and create your own special photoshoot at a beautiful location.",
supplies:[
"Camera",
"Outfits",
"Props"
],
memory:"Choose your favorite photo together."
},


{
name:"🎨 Couples Workshop",
location:"outside",
budget:"splurge",
vibes:[
"creative",
"adventure"
],
difficulty:"medium",
time:"2-3 hours",
description:"Try a new experience together like pottery, painting, cooking, or another creative class.",
supplies:[
"Reservation",
"Curiosity"
],
memory:"Keep something you created together."
},


{
name:"🍽️ Fancy Restaurant Challenge",
location:"outside",
budget:"splurge",
vibes:[
"foodie",
"romantic"
],
difficulty:"easy",
time:"2 hours",
description:"Dress up and visit a restaurant you normally would not choose. Make the evening feel like an event.",
supplies:[
"Reservation",
"Nice outfit"
],
memory:"Take a photo from your special dinner."
},


{
name:"🎁 Ultimate Surprise Date",
location:"any",
budget:"splurge",
vibes:[
"romantic",
"adventure",
"silly"
],
difficulty:"medium",
time:"2-4 hours",
description:"Each person secretly plans part of the perfect date and reveals the surprise during the adventure.",
supplies:[
"Planning",
"Creativity"
],
memory:"Capture the biggest surprise moment."
},

{
name:"🏺 Pottery Class Adventure",
location:"outside",
budget:"splurge",
vibes:[
"creative",
"romantic",
"adventure"
],
difficulty:"medium",
time:"2-3 hours",
description:"Take a pottery class together and create something you can keep forever. Laugh through the mistakes and enjoy learning something new.",
supplies:[
"Reservation",
"Curiosity"
],
memory:"Take a photo of your creations together."
},


{
name:"💃 Dance Lesson Date",
location:"outside",
budget:"splurge",
vibes:[
"creative",
"romantic",
"adventure"
],
difficulty:"medium",
time:"1-2 hours",
description:"Learn a new dance style together. It does not matter if you are good — the goal is laughing and making memories.",
supplies:[
"Reservation",
"Comfortable clothes"
],
memory:"Record your favorite dance moment."
},


{
name:"🎨 Professional Art Workshop",
location:"outside",
budget:"splurge",
vibes:[
"creative"
],
difficulty:"medium",
time:"2-3 hours",
description:"Attend a creative workshop together like painting, crafts, or another hands-on experience.",
supplies:[
"Reservation",
"Creative mindset"
],
memory:"Save the artwork you create."
},


{
name:"📷 Photography Adventure",
location:"outside",
budget:"splurge",
vibes:[
"creative",
"adventure"
],
difficulty:"easy",
time:"2-3 hours",
description:"Spend the day taking beautiful photos of each other and exploring interesting locations.",
supplies:[
"Camera or phone",
"Locations to explore"
],
memory:"Create a favorite photo album."
},


{
name:"🍳 Couples Cooking Class",
location:"outside",
budget:"splurge",
vibes:[
"foodie",
"creative",
"romantic"
],
difficulty:"medium",
time:"2-3 hours",
description:"Learn how to make a new dish together with guidance from a professional.",
supplies:[
"Reservation",
"Appetite"
],
memory:"Recreate the recipe at home later."
},


{
name:"🗝️ Escape Room Challenge",
location:"outside",
budget:"splurge",
vibes:[
"adventure",
"silly"
],
difficulty:"medium",
time:"1-2 hours",
description:"Work together to solve puzzles and escape before time runs out.",
supplies:[
"Reservation",
"Teamwork"
],
memory:"Take a victory or defeat photo."
},


{
name:"🎡 Theme Park Adventure",
location:"outside",
budget:"splurge",
vibes:[
"adventure",
"silly"
],
difficulty:"medium",
time:"4-8 hours",
description:"Spend the day riding attractions, playing games, and acting like kids again.",
supplies:[
"Tickets",
"Comfortable shoes"
],
memory:"Capture your funniest ride photo."
},


{
name:"🐎 Horseback Riding Experience",
location:"outside",
budget:"splurge",
vibes:[
"adventure",
"romantic"
],
difficulty:"medium",
time:"2-3 hours",
description:"Explore a trail together on horseback and experience something completely different.",
supplies:[
"Reservation",
"Outdoor clothes"
],
memory:"Take a photo during your adventure."
},


{
name:"🚣 Water Adventure Day",
location:"outside",
budget:"splurge",
vibes:[
"adventure"
],
difficulty:"medium",
time:"3-5 hours",
description:"Try kayaking, canoeing, paddleboarding, or another water activity together.",
supplies:[
"Reservation",
"Weather appropriate clothing"
],
memory:"Save your best adventure photo."
},


{
name:"🛣️ Ultimate Road Trip Day",
location:"outside",
budget:"splurge",
vibes:[
"adventure",
"romantic"
],
difficulty:"medium",
time:"Full day",
description:"Pick a destination, create a playlist, pack snacks, and turn the drive into the adventure.",
supplies:[
"Vehicle",
"Playlist",
"Snacks"
],
memory:"Take a photo at your destination."
},


{
name:"🍽️ Chef Tasting Experience",
location:"outside",
budget:"splurge",
vibes:[
"foodie",
"romantic"
],
difficulty:"easy",
time:"2-3 hours",
description:"Try a special tasting menu and experience a meal you normally would not choose.",
supplies:[
"Reservation",
"Nice outfit"
],
memory:"Save your favorite course."
},


{
name:"☕ Specialty Coffee Tour",
location:"outside",
budget:"splurge",
vibes:[
"foodie",
"adventure"
],
difficulty:"easy",
time:"2-4 hours",
description:"Visit multiple unique cafes and compare your favorite drinks and treats.",
supplies:[
"Transportation",
"Budget"
],
memory:"Create your coffee ranking list."
},


{
name:"🍰 Dessert Crawl",
location:"outside",
budget:"splurge",
vibes:[
"foodie",
"silly"
],
difficulty:"easy",
time:"2-3 hours",
description:"Visit multiple dessert locations and decide who makes the best treat.",
supplies:[
"Transportation",
"Sweet tooth"
],
memory:"Take photos of every dessert winner."
},


{
name:"🧀 Gourmet Picnic Experience",
location:"outside",
budget:"splurge",
vibes:[
"foodie",
"romantic"
],
difficulty:"easy",
time:"2-3 hours",
description:"Create a luxury picnic with special foods, drinks, and a beautiful location.",
supplies:[
"Fancy snacks",
"Blanket",
"Location"
],
memory:"Take a photo of your picnic setup."
},


{
name:"🎤 Comedy Show Night",
location:"outside",
budget:"splurge",
vibes:[
"silly",
"adventure"
],
difficulty:"easy",
time:"2-3 hours",
description:"Dress up and enjoy a night of laughs together.",
supplies:[
"Tickets",
"Transportation"
],
memory:"Save your favorite funny moment."
},


{
name:"🕹️ Premium Arcade Night",
location:"outside",
budget:"splurge",
vibes:[
"silly",
"adventure"
],
difficulty:"easy",
time:"2-3 hours",
description:"Compete in arcade games and see who becomes the champion.",
supplies:[
"Game credits",
"Competitive spirit"
],
memory:"Take a winner photo."
},


{
name:"🎭 Costume Dinner Challenge",
location:"inside",
budget:"splurge",
vibes:[
"silly",
"creative"
],
difficulty:"medium",
time:"2 hours",
description:"Dress up as characters or themes and create a ridiculous fancy dinner experience.",
supplies:[
"Costumes",
"Food"
],
memory:"Take your funniest dressed-up photo."
},


{
name:"🏆 Couple Olympics",
location:"outside",
budget:"splurge",
vibes:[
"silly",
"adventure"
],
difficulty:"medium",
time:"2-4 hours",
description:"Create a series of challenges and compete for the ultimate relationship championship.",
supplies:[
"Games",
"Score sheet",
"Prize"
],
memory:"Create a champion photo."
},


{
name:"🎪 Unique Event Adventure",
location:"outside",
budget:"splurge",
vibes:[
"adventure",
"creative"
],
difficulty:"easy",
time:"2-4 hours",
description:"Find a unique local event, festival, exhibit, or experience and explore it together.",
supplies:[
"Tickets if needed",
"Curiosity"
],
memory:"Take a photo from the event."
},


{
name:"🎨 Pottery Painting Date",
location:"inside",
budget:"medium",
vibes:[
"creative",
"romantic",
"relaxing"
],
difficulty:"easy",
time:"1-2 hours",
description:"Visit a pottery studio and paint something for each other or create something for your home together.",
supplies:[
"Transportation",
"Creative ideas"
],
memory:"Take a photo of your finished pottery pieces."
},


{
name:"🧩 Escape Room Challenge",
location:"inside",
budget:"medium",
vibes:[
"adventure",
"silly",
"creative"
],
difficulty:"medium",
time:"1-2 hours",
description:"Work together to solve puzzles, uncover clues, and escape before time runs out.",
supplies:[
"Reservation",
"Teamwork"
],
memory:"Take a victory photo after escaping."
},


{
name:"🎤 Comedy Show Night",
location:"outside",
budget:"medium",
vibes:[
"silly",
"romantic"
],
difficulty:"easy",
time:"2-3 hours",
description:"Go see a local comedy show and enjoy an evening full of laughs together.",
supplies:[
"Tickets",
"Transportation"
],
memory:"Save a photo from your night out."
},


{
name:"🖌️ Paint Night Experience",
location:"inside",
budget:"medium",
vibes:[
"creative",
"romantic"
],
difficulty:"easy",
time:"2-3 hours",
description:"Follow along with a guided painting activity and create artwork together.",
supplies:[
"Paint supplies",
"Reference image"
],
memory:"Hang your paintings somewhere meaningful."
},


{
name:"⛳ Mini Golf Date",
location:"outside",
budget:"medium",
vibes:[
"silly",
"adventure",
"romantic"
],
difficulty:"easy",
time:"1-2 hours",
description:"Challenge each other to a friendly round of mini golf and celebrate the winner.",
supplies:[
"Transportation",
"Scorecard"
],
memory:"Take a photo with the final score."
},


{
name:"🍹 Specialty Drink Tasting",
location:"outside",
budget:"medium",
vibes:[
"foodie",
"romantic",
"adventure"
],
difficulty:"easy",
time:"1-2 hours",
description:"Visit different cafes or drink spots and compare unique drinks together.",
supplies:[
"Transportation",
"Budget"
],
memory:"Create a ranking of your favorites."
},


{
name:"🏛️ Museum Adventure",
location:"outside",
budget:"medium",
vibes:[
"creative",
"adventure",
"relaxing"
],
difficulty:"easy",
time:"2-3 hours",
description:"Explore a museum together and discover something new while taking your time.",
supplies:[
"Tickets",
"Curiosity"
],
memory:"Take a photo beside your favorite exhibit."
},


{
name:"🎳 Bowling Night",
location:"outside",
budget:"medium",
vibes:[
"silly",
"adventure",
"romantic"
],
difficulty:"easy",
time:"1-2 hours",
description:"Go bowling, compete for the highest score, and enjoy some friendly competition.",
supplies:[
"Transportation",
"Bowling shoes"
],
memory:"Take a photo of the scoreboard."
},


{
name:"🧁 Baking Class Together",
location:"inside",
budget:"medium",
vibes:[
"foodie",
"creative",
"romantic"
],
difficulty:"medium",
time:"2-3 hours",
description:"Learn a new recipe or baking skill together through a class or guided activity.",
supplies:[
"Reservation",
"Creative energy"
],
memory:"Take a photo of your finished creation."
},


{
name:"🌿 Botanical Garden Visit",
location:"outside",
budget:"medium",
vibes:[
"romantic",
"relaxing",
"adventure"
],
difficulty:"easy",
time:"2-3 hours",
description:"Walk through beautiful gardens, enjoy nature, and spend quiet quality time together.",
supplies:[
"Comfortable shoes",
"Camera"
],
memory:"Take a photo at your favorite garden spot."
},


{
name:"🍽️ Fancy Dinner Experience",
location:"outside",
budget:"medium",
vibes:[
"foodie",
"romantic"
],
difficulty:"easy",
time:"2-3 hours",
description:"Dress up and go somewhere nicer than your usual restaurant. Make the meal feel like an event instead of just dinner.",
supplies:[
"Reservation",
"Nice outfit optional"
],
memory:"Take a photo before your meal."
},


{
name:"☕ Cafe Crawl Challenge",
location:"outside",
budget:"medium",
vibes:[
"foodie",
"adventure",
"creative"
],
difficulty:"easy",
time:"2-3 hours",
description:"Visit multiple cafes and compare drinks, desserts, atmosphere, and favorites.",
supplies:[
"Transportation",
"Budget",
"Phone camera"
],
memory:"Create your official cafe rankings."
},


{
name:"🧖 Couples Spa Evening",
location:"inside",
budget:"medium",
vibes:[
"relaxing",
"romantic"
],
difficulty:"easy",
time:"1-2 hours",
description:"Spend an evening relaxing together with massages, spa treatments, or a DIY spa setup.",
supplies:[
"Reservation or supplies",
"Relaxing music"
],
memory:"Take a relaxing selfie together."
},


{
name:"🐠 Aquarium Adventure",
location:"outside",
budget:"medium",
vibes:[
"adventure",
"relaxing",
"creative"
],
difficulty:"easy",
time:"2-3 hours",
description:"Explore an aquarium together and discover your favorite creatures.",
supplies:[
"Tickets",
"Camera"
],
memory:"Take a photo with your favorite animal."
},


{
name:"🎮 Arcade Night Challenge",
location:"outside",
budget:"medium",
vibes:[
"silly",
"adventure"
],
difficulty:"easy",
time:"1-2 hours",
description:"Visit an arcade and compete in different games. Winner gets bragging rights.",
supplies:[
"Tokens or game credits"
],
memory:"Take a photo of your highest score."
},


{
name:"🧺 Gourmet Picnic Date",
location:"outside",
budget:"medium",
vibes:[
"foodie",
"romantic",
"relaxing"
],
difficulty:"easy",
time:"1-2 hours",
description:"Create a nicer picnic experience with special food, drinks, and a beautiful location.",
supplies:[
"Food",
"Blanket",
"Drinks"
],
memory:"Take a photo of your picnic setup."
},


{
name:"🎟️ Local Event Night",
location:"outside",
budget:"medium",
vibes:[
"adventure",
"silly",
"creative"
],
difficulty:"easy",
time:"2-3 hours",
description:"Find a local event, market, performance, or activity and make an evening out of it.",
supplies:[
"Tickets if needed",
"Transportation"
],
memory:"Save a photo from the event."
},


{
name:"📚 Bookstore & Coffee Date",
location:"outside",
budget:"medium",
vibes:[
"relaxing",
"creative",
"foodie"
],
difficulty:"easy",
time:"1-2 hours",
description:"Browse a bookstore together, pick interesting books, and relax with coffee afterward.",
supplies:[
"Transportation",
"Small budget"
],
memory:"Take a photo of the books you discovered."
},


{
name:"🍳 Cooking Workshop",
location:"inside",
budget:"medium",
vibes:[
"foodie",
"creative",
"adventure"
],
difficulty:"medium",
time:"2-3 hours",
description:"Learn a new cooking skill together through a class or guided recipe experience.",
supplies:[
"Ingredients",
"Reservation"
],
memory:"Take a photo of your finished dish."
},


{
name:"🎲 Trivia Night Out",
location:"outside",
budget:"medium",
vibes:[
"silly",
"adventure",
"relaxing"
],
difficulty:"easy",
time:"2-3 hours",
description:"Join a trivia night and compete as a team or challenge each other.",
supplies:[
"Transportation",
"Team name"
],
memory:"Save your final score."
},


{
name:"🕯️ Cozy Candlelight Evening",
location:"inside",
budget:"cheap",
vibes:[
"relaxing",
"romantic"
],
difficulty:"easy",
time:"1-2 hours",
description:"Create a calm evening with candles, soft music, snacks, and uninterrupted time together.",
supplies:[
"Candles or lights",
"Music",
"Snacks"
],
memory:"Take a photo of your cozy setup."
},


{
name:"☕ Tea Tasting Night",
location:"inside",
budget:"cheap",
vibes:[
"relaxing",
"foodie",
"creative"
],
difficulty:"easy",
time:"1 hour",
description:"Try different teas together and rate your favorites while having a quiet conversation.",
supplies:[
"Different teas",
"Mugs",
"Score cards"
],
memory:"Save your favorite tea ranking."
},


{
name:"🌌 Backyard Stargazing",
location:"outside",
budget:"free",
vibes:[
"relaxing",
"romantic",
"adventure"
],
difficulty:"easy",
time:"1-2 hours",
description:"Find a comfortable spot outside, look at the stars, and spend time talking without distractions.",
supplies:[
"Blanket",
"Warm clothes"
],
memory:"Take a photo of the sky together."
},


{
name:"🍫 Hot Chocolate Walk",
location:"outside",
budget:"cheap",
vibes:[
"relaxing",
"romantic",
"adventure"
],
difficulty:"easy",
time:"1 hour",
description:"Grab a warm drink and take a peaceful walk together while enjoying the evening.",
supplies:[
"Warm drinks",
"Walking shoes"
],
memory:"Take a photo during your walk."
},


{
name:"📖 Read Together Night",
location:"inside",
budget:"free",
vibes:[
"relaxing",
"creative"
],
difficulty:"easy",
time:"1 hour",
description:"Choose books, articles, or stories and spend quiet time reading together.",
supplies:[
"Books",
"Comfortable space"
],
memory:"Save a favorite quote you discovered."
},


{
name:"🛁 At Home Spa Night",
location:"inside",
budget:"cheap",
vibes:[
"relaxing",
"romantic"
],
difficulty:"easy",
time:"1-2 hours",
description:"Create a relaxing spa experience at home with music, skincare, and self-care activities.",
supplies:[
"Relaxation supplies",
"Music",
"Comfortable clothes"
],
memory:"Take a relaxing photo together."
},


{
name:"🌧️ Rainy Day Indoor Escape",
location:"inside",
budget:"free",
vibes:[
"relaxing",
"creative",
"romantic"
],
difficulty:"easy",
time:"1-2 hours",
description:"Turn a rainy day into a cozy adventure with blankets, drinks, games, and conversation.",
supplies:[
"Blankets",
"Snacks",
"Entertainment"
],
memory:"Take a cozy rainy day photo."
},


{
name:"🎧 Relaxing Music Discovery",
location:"inside",
budget:"free",
vibes:[
"relaxing",
"creative"
],
difficulty:"easy",
time:"1 hour",
description:"Share favorite songs, discover new music, and create a playlist together.",
supplies:[
"Phone",
"Music app"
],
memory:"Save your new playlist."
},


{
name:"🌿 Nature Quiet Time",
location:"outside",
budget:"free",
vibes:[
"relaxing",
"adventure"
],
difficulty:"easy",
time:"1-2 hours",
description:"Visit a peaceful outdoor location and spend time enjoying nature without rushing.",
supplies:[
"Walking shoes",
"Water"
],
memory:"Take a peaceful nature photo."
},


{
name:"🍿 Upgrade Movie Night",
location:"inside",
budget:"cheap",
vibes:[
"relaxing",
"romantic",
"foodie"
],
difficulty:"easy",
time:"2-3 hours",
description:"Turn a normal movie night into an experience with themed snacks, blankets, and a cozy setup.",
supplies:[
"Movie",
"Snacks",
"Blankets"
],
memory:"Take a photo of your movie setup."
},


{
name:"🌮 Build Your Own Taco Night",
location:"inside",
budget:"cheap",
vibes:[
"foodie",
"creative",
"silly"
],
difficulty:"easy",
time:"1-2 hours",
description:"Create a taco bar together with different toppings and see who makes the best creation.",
supplies:[
"Taco ingredients",
"Toppings",
"Music"
],
memory:"Take a photo of your taco creations."
},


{
name:"🍕 Homemade Pizza Challenge",
location:"inside",
budget:"cheap",
vibes:[
"foodie",
"creative",
"silly"
],
difficulty:"easy",
time:"1-2 hours",
description:"Make homemade pizzas and compete to create the best or strangest combination.",
supplies:[
"Pizza ingredients",
"Oven",
"Creativity"
],
memory:"Take a photo of your final pizzas."
},


{
name:"🍜 International Food Night",
location:"inside",
budget:"cheap",
vibes:[
"foodie",
"creative",
"adventure"
],
difficulty:"easy",
time:"2-3 hours",
description:"Pick a country and create or order food inspired by that culture.",
supplies:[
"Recipe or restaurant",
"Ingredients"
],
memory:"Save a photo of the meal and country choice."
},


{
name:"🍰 Dessert Tour",
location:"outside",
budget:"medium",
vibes:[
"foodie",
"adventure",
"romantic"
],
difficulty:"easy",
time:"2-3 hours",
description:"Visit different dessert locations and rank your favorites.",
supplies:[
"Transportation",
"Budget"
],
memory:"Create a dessert ranking list."
},


{
name:"☕ Coffee Shop Hop",
location:"outside",
budget:"cheap",
vibes:[
"foodie",
"adventure",
"relaxing"
],
difficulty:"easy",
time:"2-3 hours",
description:"Visit multiple coffee shops and compare drinks, atmosphere, and favorites.",
supplies:[
"Transportation",
"Coffee budget"
],
memory:"Take photos of each stop."
},


{
name:"🍳 Breakfast Date Adventure",
location:"outside",
budget:"medium",
vibes:[
"foodie",
"romantic",
"adventure"
],
difficulty:"easy",
time:"1-2 hours",
description:"Find a new breakfast spot and make the morning feel like a special event.",
supplies:[
"Transportation",
"Reservation if needed"
],
memory:"Take a morning adventure photo."
},


{
name:"🍿 Snack Taste Test",
location:"inside",
budget:"cheap",
vibes:[
"foodie",
"silly"
],
difficulty:"easy",
time:"1 hour",
description:"Buy different snacks and rate them from best to worst.",
supplies:[
"Snacks",
"Rating cards"
],
memory:"Save your final rankings."
},


{
name:"👨‍🍳 Mystery Ingredient Challenge",
location:"inside",
budget:"cheap",
vibes:[
"foodie",
"creative",
"silly"
],
difficulty:"medium",
time:"1-2 hours",
description:"Choose random ingredients and create a meal together.",
supplies:[
"Ingredients",
"Kitchen"
],
memory:"Take a photo of your mystery creation."
},


{
name:"🍷 Fancy Tasting Night At Home",
location:"inside",
budget:"medium",
vibes:[
"foodie",
"romantic",
"relaxing"
],
difficulty:"easy",
time:"1-2 hours",
description:"Create a tasting experience with different foods, drinks, or desserts at home.",
supplies:[
"Tasting items",
"Plates",
"Notes"
],
memory:"Rate your favorites together."
},


{
name:"🏮 Food Market Adventure",
location:"outside",
budget:"medium",
vibes:[
"foodie",
"adventure",
"creative"
],
difficulty:"easy",
time:"2-3 hours",
description:"Explore a local market, try new foods, and discover something you've never had before.",
supplies:[
"Transportation",
"Budget"
],
memory:"Take photos of your discoveries."
}


];